export const parseJwt = (token: string): Record<string, string> => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => {
        const s = `00${c.charCodeAt(0).toString(16)}`.slice(-2);
        return `%${s}`;
      })
      .join('')
  );

  return JSON.parse(jsonPayload) as Record<string, string>;
};
